export enum AgeType {
    MAJOR,
    MINOR
}

export enum AgeTranslations {
    MAJOR = 'lang.tiebreak.majorAge',
    MINOR = 'lang.tiebreak.minorAge'
}
